export const neighbourhoodTree = [
  {
    region: 'London',
    counties: [
      {
        county: 'Greater London',
        prefix: 'london/greater-london',
        boroughs: [
          { value: 'barking-and-dagenham', label: 'Barking and Dagenham' },
          { value: 'barnet', label: 'Barnet' },
          { value: 'bexley', label: 'Bexley' },
          { value: 'brent', label: 'Brent' },
          { value: 'bromley', label: 'Bromley' },
          { value: 'camden', label: 'Camden' },
          { value: 'croydon', label: 'Croydon' },
          { value: 'ealing', label: 'Ealing' },
          { value: 'enfield', label: 'Enfield' },
          { value: 'greenwich', label: 'Greenwich' },
          { value: 'hackney', label: 'Hackney' },
          { value: 'hammersmith-and-fulham', label: 'Hammersmith and Fulham' },
          { value: 'haringey', label: 'Haringey' },
          { value: 'harrow', label: 'Harrow' },
          { value: 'havering', label: 'Havering' },
          { value: 'hillingdon', label: 'Hillingdon' },
          { value: 'hounslow', label: 'Hounslow' },
          { value: 'islington', label: 'Islington' },
          { value: 'kensington-and-chelsea', label: 'Kensington and Chelsea' },
          { value: 'kingston-upon-thames', label: 'Kingston upon Thames' },
          { value: 'lambeth', label: 'Lambeth' },
          { value: 'lewisham', label: 'Lewisham' },
          { value: 'merton', label: 'Merton' },
          { value: 'newham', label: 'Newham' },
          { value: 'redbridge', label: 'Redbridge' },
          { value: 'richmond-upon-thames', label: 'Richmond upon Thames' },
          { value: 'southwark', label: 'Southwark' },
          { value: 'sutton', label: 'Sutton' },
          { value: 'tower-hamlets', label: 'Tower Hamlets' },
          { value: 'waltham-forest', label: 'Waltham Forest' },
          { value: 'wandsworth', label: 'Wandsworth' },
          { value: 'westminster', label: 'Westminster' },
        ],
      },
      {
        county: 'City of London',
        prefix: 'london/city-of-london',
        boroughs: [{ value: 'city-of-london', label: 'City of London' }],
      },
    ],
  },
  {
    region: 'South East',
    counties: [
      {
        county: 'Berkshire',
        prefix: 'south-east/berkshire',
        boroughs: [
          { value: 'bracknell-forest', label: 'Bracknell Forest' },
          { value: 'reading', label: 'Reading' },
          { value: 'slough', label: 'Slough' },
          { value: 'west-berkshire', label: 'West Berkshire' },
          { value: 'windsor-and-maidenhead', label: 'Windsor and Maidenhead' },
          { value: 'wokingham', label: 'Wokingham' },
        ],
      },
      {
        county: 'Buckinghamshire',
        prefix: 'south-east/buckinghamshire',
        boroughs: [{ value: 'milton-keynes', label: 'Milton Keynes' }],
      },
      {
        county: 'East Sussex',
        prefix: 'south-east/east-sussex',
        boroughs: [
          { value: 'brighton-and-hove', label: 'Brighton and Hove' },
          { value: 'lewes', label: 'Lewes' },
          { value: 'wealden', label: 'Wealden' },
        ],
      },
      {
        county: 'Hampshire',
        prefix: 'south-east/hampshire',
        boroughs: [
          { value: 'basingstoke-and-deane', label: 'Basingstoke and Deane' },
          { value: 'east-hampshire', label: 'East Hampshire' },
          { value: 'eastleigh', label: 'Eastleigh' },
          { value: 'fareham', label: 'Fareham' },
          { value: 'gosport', label: 'Gosport' },
          { value: 'hart', label: 'Hart' },
          { value: 'havant', label: 'Havant' },
          { value: 'new-forest', label: 'New Forest' },
          { value: 'portsmouth', label: 'Portsmouth' },
          { value: 'rushmoor', label: 'Rushmoor' },
          { value: 'southampton', label: 'Southampton' },
          { value: 'test-valley', label: 'Test Valley' },
          { value: 'winchester', label: 'Winchester' },
        ],
      },
      {
        county: 'Kent',
        prefix: 'south-east/kent',
        boroughs: [
          { value: 'ashford', label: 'Ashford' },
          { value: 'canterbury', label: 'Canterbury' },
          { value: 'dartford', label: 'Dartford' },
          { value: 'dover', label: 'Dover' },
          { value: 'folkestone-and-hythe', label: 'Folkestone and Hythe' },
          { value: 'gravesham', label: 'Gravesham' },
          { value: 'maidstone', label: 'Maidstone' },
          { value: 'medway', label: 'Medway' },
          { value: 'sevenoaks', label: 'Sevenoaks' },
          { value: 'swale', label: 'Swale' },
          { value: 'thanet', label: 'Thanet' },
          { value: 'tonbridge-and-malling', label: 'Tonbridge and Malling' },
          { value: 'tunbridge-wells', label: 'Tunbridge Wells' },
        ],
      },
      {
        county: 'Oxfordshire',
        prefix: 'south-east/oxfordshire',
        boroughs: [
          { value: 'cherwell', label: 'Cherwell' },
          { value: 'oxford', label: 'Oxford' },
          { value: 'south-oxfordshire', label: 'South Oxfordshire' },
          { value: 'vale-of-white-horse', label: 'Vale of White Horse' },
          { value: 'west-oxfordshire', label: 'West Oxfordshire' },
        ],
      },
      {
        county: 'Surrey',
        prefix: 'south-east/surrey',
        boroughs: [
          { value: 'elmbridge', label: 'Elmbridge' },
          { value: 'epsom-and-ewell', label: 'Epsom and Ewell' },
          { value: 'guildford', label: 'Guildford' },
          { value: 'mole-valley', label: 'Mole Valley' },
          { value: 'reigate-and-banstead', label: 'Reigate and Banstead' },
          { value: 'runnymede', label: 'Runnymede' },
          { value: 'spelthorne', label: 'Spelthorne' },
          { value: 'surrey-heath', label: 'Surrey Heath' },
          { value: 'tandridge', label: 'Tandridge' },
          { value: 'waverley', label: 'Waverley' },
          { value: 'woking', label: 'Woking' },
        ],
      },
      {
        county: 'West Sussex',
        prefix: 'south-east/west-sussex',
        boroughs: [
          { value: 'adur', label: 'Adur' },
          { value: 'arun', label: 'Arun' },
          { value: 'chichester', label: 'Chichester' },
          { value: 'crawley', label: 'Crawley' },
          { value: 'horsham', label: 'Horsham' },
          { value: 'mid-sussex', label: 'Mid Sussex' },
          { value: 'worthing', label: 'Worthing' },
        ],
      },
    ],
  },
  {
    region: 'South West',
    counties: [
      {
        county: 'Bristol',
        prefix: 'south-west/bristol',
        boroughs: [{ value: 'city-of-bristol', label: 'City of Bristol' }],
      },
      {
        county: 'Devon',
        prefix: 'south-west/devon',
        boroughs: [
          { value: 'east-devon', label: 'East Devon' },
          { value: 'exeter', label: 'Exeter' },
          { value: 'mid-devon', label: 'Mid Devon' },
          { value: 'south-hams', label: 'South Hams' },
          { value: 'teignbridge', label: 'Teignbridge' },
          { value: 'torridge', label: 'Torridge' },
          { value: 'west-devon', label: 'West Devon' },
        ],
      },
      {
        county: 'Dorset',
        prefix: 'south-west/dorset',
        boroughs: [
          {
            value: 'bournemouth-christchurch-and-poole',
            label: 'Bournemouth, Christchurch and Poole',
          },
        ],
      },
      {
        county: 'Gloucestershire',
        prefix: 'south-west/gloucestershire',
        boroughs: [
          { value: 'cheltenham', label: 'Cheltenham' },
          { value: 'cotswold', label: 'Cotswold' },
          { value: 'forest-of-dean', label: 'Forest of Dean' },
          { value: 'gloucester', label: 'Gloucester' },
          { value: 'stroud', label: 'Stroud' },
        ],
      },
      {
        county: 'South Gloucestershire',
        prefix: 'south-west/south-gloucestershire',
        boroughs: [{ value: 'south-gloucestershire', label: 'South Gloucestershire' }],
      },
      {
        county: 'Somerset',
        prefix: 'south-west/somerset',
        boroughs: [
          { value: 'bath-and-north-east-somerset', label: 'Bath and North East Somerset' },
          { value: 'north-somerset', label: 'North Somerset' },
        ],
      },
      {
        county: 'Swindon',
        prefix: 'south-west/swindon',
        boroughs: [{ value: 'swindon', label: 'Swindon' }],
      },
      {
        county: 'Wiltshire',
        prefix: 'south-west/wiltshire',
        boroughs: [{ value: 'wiltshire', label: 'Wiltshire' }],
      },
    ],
  },
  {
    region: 'East Midlands',
    counties: [
      {
        county: 'Derbyshire',
        prefix: 'east-midlands/derbyshire',
        boroughs: [
          { value: 'amber-valley', label: 'Amber Valley' },
          { value: 'bolsover', label: 'Bolsover' },
          { value: 'chesterfield', label: 'Chesterfield' },
          { value: 'derby', label: 'Derby' },
          { value: 'derbyshire-dales', label: 'Derbyshire Dales' },
          { value: 'erewash', label: 'Erewash' },
          { value: 'high-peak', label: 'High Peak' },
          { value: 'north-east-derbyshire', label: 'North East Derbyshire' },
          { value: 'south-derbyshire', label: 'South Derbyshire' },
        ],
      },
      {
        county: 'Lincolnshire',
        prefix: 'east-midlands/lincolnshire',
        boroughs: [{ value: 'lincoln', label: 'Lincoln' }],
      },
      {
        county: 'Northamptonshire',
        prefix: 'east-midlands/northamptonshire',
        boroughs: [
          { value: 'north-northamptonshire', label: 'North Northamptonshire' },
          { value: 'west-northamptonshire', label: 'West Northamptonshire' },
        ],
      },
      {
        county: 'Nottinghamshire',
        prefix: 'east-midlands/nottinghamshire',
        boroughs: [
          { value: 'ashfield', label: 'Ashfield' },
          { value: 'bassetlaw', label: 'Bassetlaw' },
          { value: 'broxtowe', label: 'Broxtowe' },
          { value: 'gedling', label: 'Gedling' },
          { value: 'mansfield', label: 'Mansfield' },
          { value: 'newark-and-sherwood', label: 'Newark and Sherwood' },
          { value: 'nottingham', label: 'Nottingham' },
          { value: 'rushcliffe', label: 'Rushcliffe' },
        ],
      },
    ],
  },
  {
    region: 'East of England',
    counties: [
      {
        county: 'Bedfordshire',
        prefix: 'east-of-england/bedfordshire',
        boroughs: [
          { value: 'bedford', label: 'Bedford' },
          { value: 'central-bedfordshire', label: 'Central Bedfordshire' },
          { value: 'luton', label: 'Luton' },
        ],
      },
      {
        county: 'Cambridgeshire',
        prefix: 'east-of-england/cambridgeshire',
        boroughs: [
          { value: 'cambridge', label: 'Cambridge' },
          { value: 'east-cambridgeshire', label: 'East Cambridgeshire' },
          { value: 'fenland', label: 'Fenland' },
          { value: 'huntingdonshire', label: 'Huntingdonshire' },
          { value: 'south-cambridgeshire', label: 'South Cambridgeshire' },
        ],
      },
      {
        county: 'Peterborough',
        prefix: 'east-of-england/peterborough',
        boroughs: [{ value: 'peterborough', label: 'Peterborough' }],
      },
      {
        county: 'Essex',
        prefix: 'east-of-england/essex',
        boroughs: [
          { value: 'basildon', label: 'Basildon' },
          { value: 'braintree', label: 'Braintree' },
          { value: 'brentwood', label: 'Brentwood' },
          { value: 'castle-point', label: 'Castle Point' },
          { value: 'chelmsford', label: 'Chelmsford' },
          { value: 'colchester', label: 'Colchester' },
          { value: 'epping-forest', label: 'Epping Forest' },
          { value: 'harlow', label: 'Harlow' },
          { value: 'maldon', label: 'Maldon' },
          { value: 'rochford', label: 'Rochford' },
          { value: 'southend-on-sea', label: 'Southend-on-Sea' },
          { value: 'tendring', label: 'Tendring' },
          { value: 'thurrock', label: 'Thurrock' },
          { value: 'uttlesford', label: 'Uttlesford' },
        ],
      },
      {
        county: 'Hertfordshire',
        prefix: 'east-of-england/hertfordshire',
        boroughs: [
          { value: 'east-hertfordshire', label: 'East Hertfordshire' },
          { value: 'st-albans', label: 'St Albans' },
          { value: 'stevenage', label: 'Stevenage' },
          { value: 'welwyn-hatfield', label: 'Welwyn Hatfield' },
        ],
      },
    ],
  },
  {
    region: 'West Midlands',
    counties: [
      {
        county: 'Herefordshire',
        prefix: 'west-midlands/herefordshire',
        boroughs: [{ value: 'county-of-herefordshire', label: 'County of Herefordshire' }],
      },
      {
        county: 'Warwickshire',
        prefix: 'west-midlands/warwickshire',
        boroughs: [{ value: 'warwickshire', label: 'Warwickshire' }],
      },
      {
        county: 'West Midlands',
        prefix: 'west-midlands/west-midlands',
        boroughs: [
          { value: 'birmingham', label: 'Birmingham' },
          { value: 'coventry', label: 'Coventry' },
          { value: 'dudley', label: 'Dudley' },
          { value: 'sandwell', label: 'Sandwell' },
          { value: 'solihull', label: 'Solihull' },
          { value: 'wolverhampton', label: 'Wolverhampton' },
        ],
      },
    ],
  },
  {
    region: 'North East',
    counties: [
      {
        county: 'Cheshire',
        prefix: 'north-east/cheshire',
        boroughs: [
          { value: 'cheshire-east', label: 'Cheshire East' },
          { value: 'cheshire-west-and-chester', label: 'Cheshire West and Chester' },
          { value: 'halton', label: 'Halton' },
          { value: 'warrington', label: 'Warrington' },
        ],
      },
      {
        county: 'Greater Manchester',
        prefix: 'north-east/greater-manchester',
        boroughs: [
          { value: 'bolton', label: 'Bolton' },
          { value: 'bury', label: 'Bury' },
          { value: 'manchester', label: 'Manchester' },
          { value: 'oldham', label: 'Oldham' },
          { value: 'rochdale', label: 'Rochdale' },
          { value: 'salford', label: 'Salford' },
          { value: 'stockport', label: 'Stockport' },
          { value: 'tameside', label: 'Tameside' },
          { value: 'trafford', label: 'Trafford' },
          { value: 'wigan', label: 'Wigan' },
        ],
      },
      {
        county: 'Lancashire',
        prefix: 'north-east/lancashire',
        boroughs: [
          { value: 'blackburn-with-darwen', label: 'Blackburn with Darwen' },
          { value: 'burnley', label: 'Burnley' },
          { value: 'chorley', label: 'Chorley' },
          { value: 'hyndburn', label: 'Hyndburn' },
          { value: 'lancaster', label: 'Lancaster' },
          { value: 'preston', label: 'Preston' },
          { value: 'ribble-valley', label: 'Ribble Valley' },
          { value: 'rossendale', label: 'Rossendale' },
          { value: 'south-ribble', label: 'South Ribble' },
          { value: 'west-lancashire', label: 'West Lancashire' },
        ],
      },
      {
        county: 'Merseyside',
        prefix: 'north-east/merseyside',
        boroughs: [
          { value: 'knowsley', label: 'Knowsley' },
          { value: 'liverpool', label: 'Liverpool' },
          { value: 'sefton', label: 'Sefton' },
          { value: 'st-helens', label: 'St. Helens' },
          { value: 'wirral', label: 'Wirral' },
        ],
      },
    ],
  },
  {
    region: 'Other (Scotland)',
    counties: [
      {
        county: 'Aberdeen City',
        prefix: 'other-scotland/aberdeen-city',
        boroughs: [{ value: 'aberdeen-city', label: 'Aberdeen City' }],
      },
    ],
  },
];

export const allNeighbourhood = neighbourhoodTree.flatMap((t) =>
  t.counties.flatMap((c) => c.boroughs.map((b) => ({ ...b, value: `${c.prefix}/${b.value}` })))
);
